import { CSSObject } from '@chakra-ui/react';

export const TabsContentContainer: CSSObject = {
  px: ['2', null, '0'],
  py: '0',
};
